module.exports = __webpack_public_path__ + "static/media/action-save-plan.e86ebacf.svg";